import React from 'react';
import { format, parse } from 'date-fns';

export default function useStoreTodayHours(operatingHours) {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const today = days[new Date().getDay()];
  const todayHoursArr = operatingHours?.[today] || [];
  const isClosedToday = todayHoursArr.length === 0;

  let formattedHours = '';
  let openTodayText = '';

  if (isClosedToday) {
    openTodayText = 'Closed Today';
  } else {
    const [openTime, closeTime] = todayHoursArr[0] || [];
    if (openTime && closeTime) {
      try {
        const open = parse(openTime, 'H:mm', new Date());
        const close = parse(closeTime, 'H:mm', new Date());
        openTodayText = 'Open Today';
        formattedHours = `${format(open, 'h:mm a')} - ${format(close, 'h:mm a')}`;
      } catch {
        openTodayText = 'Open Today';
        formattedHours = `${openTime} - ${closeTime}`;
      }
    } else {
      openTodayText = 'Closed Today';
    }
  }

  return { openTodayText, formattedHours };
}
